import React from 'react';
import { evangelismMyths, firstSteps } from '../data/content';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function ShynessObjection() {
  return <section aria-labelledby="shy-title" className="bg-cream" data-id="element-295" data-mp="25awpjanh9ko">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-296" data-mp="27ndvu8l3fwo">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-297" data-mp="3tblwzd7u66ay">
          <div data-id="element-298" data-mp="3odajmsic1dnz">
            <h2 id="shy-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-299" data-mp="3odu3ierjmc4n">
              Votre timidité n’a pas à freiner votre obéissance
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-300" data-mp="3flid2swfiooo">Vous avez peut-être pensé que l’évangélisation était réservée à…</p>
            <ul className="mt-4 space-y-2.5" data-id="element-301" data-mp="3ajt037pnc0xy">
              {evangelismMyths.map(m => <li key={m} className="text-lg text-ink-mute line-through decoration-coral/60 decoration-2" data-id="element-302" data-mp="35oneka05ooae">
                  {m}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[28px] bg-white p-8 shadow-card ring-1 ring-cream-line sm:p-10" data-id="element-303" data-mp="8liulrlde3fg">
            <p className="text-lg font-bold leading-relaxed text-navy" data-id="element-304" data-mp="dgez3r7smj9g">Mais le Grand Mandat n’a pas été confié uniquement aux pasteurs et aux missionnaires.</p>
            <p className="mt-3 text-lg leading-relaxed text-ink-soft" data-id="element-305" data-mp="3pk8kanikxi7">Et vous n’avez pas à attendre que toutes vos peurs disparaissent pour commencer.</p>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-306" data-mp="wd6cxl4kg664">Parfois, le premier pas consiste simplement à être prêt à partager :</p>
            <ul className="mt-4 space-y-1" data-id="element-307" data-mp="hevx9l98kjeq">
              {firstSteps.map(s => <li key={s} className="flex items-center gap-3 font-display text-3xl text-navy" data-id="element-308" data-mp="me7gd0x2s0zh">
                  <HeartMark className="h-4 w-4 text-coral" data-id="element-309" data-mp="325v9smcvrbdj" />
                  {s}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-310" data-mp="372v7o9zkt7tk">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-311" data-mp="1dlz8asw30eu9">Le Pack Complet d’Évangélisation vous donne un outil simple pour vous aider à faire ce premier pas.</p>
          <p className="mt-4 font-display text-[28px] leading-tight text-navy sm:text-[34px]" data-id="element-312" data-mp="13w5z1yjewbt6">
            Car vous ne saurez peut-être pas toujours exactement quoi dire…
            <span className="block italic text-coral" data-id="element-313" data-mp="tyjdwubiro0r">Mais vous pouvez toujours être prêt à semer une graine.</span>
          </p>
          <CtaButton className="mt-8" data-id="element-314" data-mp="pwoe5u98lip3">Partagez l’Évangile</CtaButton>
        </div>
      </div>
    </section>;
}